import { createFileRoute } from '@tanstack/react-router';
import { EventRequestsPage } from '../../features/event-requests/EventRequestsPage.jsx';

export const Route = createFileRoute('/_app/event-requests/')({ component: EventRequestsPage });
